// Module
var code = "<span> <a href class=\"btn btn-success\" ng-if=\"!$ctrl.checkIfInCart()\" ng-click=\"$ctrl.add()\"><span> Add to cart </span><i class=\"fas fa-shopping-cart\"></i></a> <a href=\"/cart\" class=\"btn btn-dark\" ng-if=\"$ctrl.checkIfInCart()\">In cart <i class=\"fas fa-shopping-cart\"></i></a> </span>";
// Exports
module.exports = code;